const theme = {
  token: {
    colorPrimary: "#52c41a",
  },
};

export default theme;
